import Titles from '../Titles.vue'
import StudentTitles from '../Views/StudentTitles.vue'

const StudentTitlesRoutes = {
    path: '/titles',
    meta: {
        name: {
            en: 'Titles',
            es: 'Títulos'
        }
    },
    component: Titles,
    children: [
        {
            path: '/',
            component: StudentTitles,
            name: 'StudentTitles',
        }
    ]
}

export default StudentTitlesRoutes